import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.TarifaDTO;
import { columnas } from "./columns";
const resource = resources.Tarifa;
export class TarifaList extends React.PureComponent {
    onBorrar = async (x: Entity) => {
        if (await kea.yesno("¿Borrar tarifa?", x.Nombre)) {
            await resource.delete(x.IdRegistro);
        }
    }

    items = observeResource(resource.query);
    onEdit = (x: Entity) => history.go("/catalogos/Tarifa/" + x.IdRegistro);
    onAgregar = () => history.go("/catalogos/Tarifa/new");
    onRegresar = () => history.go("/catalogos");

    render() {
        const cols = columnas(this);
        return (
            <div>
                <kea.Title titulo="Tarifas" onRegresar={this.onRegresar}>
                    <kea.AgregarButton onClick={this.onAgregar} />
                </kea.Title>
                <kea.Link onClick={() => history.go("/catalogos/MatrizTarifa/")} >Ir a matrices de tarifas</kea.Link>

                <kea.Grid2 columnas={cols} cookieKey={"TarifaListCookieKey"} items={this.items} />
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/tarifas/list/list.tsx